import { render, staticRenderFns } from "./DiscoDrawer.vue?vue&type=template&id=6210d31d&"
import script from "./DiscoDrawer.vue?vue&type=script&lang=js&"
export * from "./DiscoDrawer.vue?vue&type=script&lang=js&"
import style0 from "./DiscoDrawer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports